import Link from 'next/link';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { RECORDS_NETWORK_LINK } from '@web/features/const';
import { GenericHubTile } from '@web/features/hub-rework/GenericHubTile';

import { RECORDS_TILE_SVG_INNER } from './records-tile-svg';

const IllustrationStage = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.spacing('1000')};
  box-sizing: border-box;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: ${({ theme }) => theme.spacing('0500')};
  }
`;

const BaseSvg = styled.svg`
  width: 100%;
  max-width: 16.25rem;
  height: auto;
  overflow: visible;

  ${({ theme }) => theme.breakpoints.down('md')} {
    max-width: 13.75rem;
  }

  .record-icon-frame {
    filter: drop-shadow(2.31px 2.31px 0 #2c2b27);
  }

  .record-connector-trace {
    fill: none;
    stroke: #00ff99;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-dasharray: 32 9999;
    stroke-dashoffset: 32;
    pointer-events: none;
    filter:
      drop-shadow(0 0 4px rgba(0, 255, 153, 0.95))
      drop-shadow(0 0 10px rgba(0, 255, 153, 0.55));
    opacity: 0;
    animation: record-pulse 4.2s linear infinite;
  }

  .record-connector-trace[data-pulse-index='0'] {
    animation-delay: 0s;
  }
  .record-connector-trace[data-pulse-index='1'] {
    animation-delay: 0.45s;
  }
  .record-connector-trace[data-pulse-index='2'] {
    animation-delay: 0.95s;
  }
  .record-connector-trace[data-pulse-index='3'] {
    animation-delay: 1.55s;
  }
  .record-connector-trace[data-pulse-index='4'] {
    animation-delay: 2.1s;
  }
  .record-connector-trace[data-pulse-index='5'] {
    animation-delay: 2.7s;
  }
  .record-connector-trace[data-pulse-index='6'] {
    animation-delay: 3.3s;
  }

  @keyframes record-pulse {
    0% {
      stroke-dashoffset: 32;
      opacity: 0;
    }
    5% {
      opacity: 1;
    }
    35% {
      opacity: 1;
      stroke-dashoffset: -100%;
    }
    42% {
      opacity: 0;
      stroke-dashoffset: -100%;
    }
    100% {
      opacity: 0;
      stroke-dashoffset: -100%;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .record-connector-trace {
      animation: none;
      opacity: 0;
    }
  }
`;

const RecordsBadge = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  display: block;
`;

const RecordsIllustration = () => (
  <BaseSvg
    viewBox="0 0 643 525"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: RECORDS_TILE_SVG_INNER }}
  />
);

export const RecordsTile = () => {
  const t = useTranslations();

  return (
    <Link href={RECORDS_NETWORK_LINK} target="_blank">
      <GenericHubTile
        variant="left"
        title={t('RECORDS_HUB_TILE_TITLE')}
        subtitle={t('RECORDS_HUB_TILE_SUBTITLE')}
        description={t('RECORDS_HUB_TILE_DESCRIPTION')}
        linkText={t('RECORDS_HUB_TILE_LINK_TEXT')}
        href={RECORDS_NETWORK_LINK}
        illustration={
          <IllustrationStage>
            <RecordsIllustration />
          </IllustrationStage>
        }
        badge={
          <RecordsBadge
            src="/brand-assets/Records/Symbol/Records-Symbol-OnLight.svg"
            alt=""
          />
        }
      />
    </Link>
  );
};

